/* Copyright (c) 2020-present CloudIO Inc */

import { getManager } from '../../../componentregistry';
import { Platform } from '../../platform/Platform';
import { ActionManager, ActionManagerFn } from '../../registry/Component.type';
import { baseActionManager, baseActionProps } from '../../registry/Components';
import { defaultValue } from './ActionReduce';

const ActionReduceManager: ActionManagerFn<'ActionReduce'> = (
  platform: Platform,
): ActionManager<'ActionReduce'> => {
  return {
    ...baseActionManager(platform, 'ActionReduce'),
    isChildAllowed: (page, item, childType) =>
      getManager(childType).managerType === 'Action',
    defaultValue,
    props: {
      ...baseActionProps,
      alias: {
        label: 'Alias',
        type: 'DataSourceAliasChooser',
        required: true,
        allowedTypes: [
          'CloudDataStore',
          'DataStore',
          'LocalDataStore',
          'ReadOnlyDataStore',
        ],
      },
      initialValueExpression: {
        label: 'Initial Value Expression',
        type: 'expressionOnly',
        returnType: () => 'any',
        required: true,
        helpText:
          'This expression will be evaluated to get the initial value e.g. 0 for sum',
      },
      reduceExpression: {
        label: 'Reduce Expression',
        type: 'expressionOnly',
        returnType: () => 'any',
        required: true,
        helpText: `This expression will be evaluated for each record in the store. The result of this expression will be used to reduce the store to a single value. The expression will be passed the following variables:

1. \`reducedValue\` the value returned during the previous evaluation or the output of initial value expression for the first record.
2. \`record\` the record in the store being looped over.

Access the above variables using the following syntax:
\`$._.reducedValue\` and \`$._.record\`

The expression should return the new reducedValue.`,
      },
    },
    name: 'Reduce',
    icon: { iconName: 'rectangle-history-circle-plus' },
    description:
      'Use this action to loop through a store and to reduce it to a single value.',
  };
};

export default ActionReduceManager;
